import React, { useState,useEffect  } from "react";

import GisSiderbar from "../Common/GisSiderbar";
// import Gisdashboardmap from "./MapNewOne";
import AnalyticsPage from "./Analytics";
import SchemeReportsPage from "./SchemeReports";
import SurveyDataPage from "./SurveyDataOne";
import BhuvanMapPage from "../gis/GIS.jsx";
import AssignTargetPage from "./AssignTarget";
import PowerbiAnalytics from "./PowerbiAnalytics";
import { useLocation } from 'react-router-dom';
import BhuvanNewGenPage from "../gis/BHUWAN_NEW_GEN.jsx";

function GISDashboard() {
  const [activePage, setActivePage] = useState("gis"); // default GIS Dashboard
  const location = useLocation();
   useEffect(() => {
    if (location.pathname === "/mapDash" || location.pathname === "/gisdashboard" ) {
      import('../../assets/styles/StyleGis.css');
    }
  }, [location]);
  const renderContent = () => {
    switch (activePage) {
      // case "gis":
      //   return <Gisdashboardmap />;
      case "analytics":
        return <AnalyticsPage />;
      case "mis":
        return <SchemeReportsPage />;
      case "survey":
        return <SurveyDataPage />;
      case "bhuvan":
        return <BhuvanMapPage />;
        case "BHUWAN_NEW_GEN":
        return <BhuvanNewGenPage />;  
      case "assignTarget":
        return <AssignTargetPage />;
      case "Powerbi":
        return <PowerbiAnalytics />;
      default:
        return <BhuvanMapPage />;
    }
  };

  return (
    <>
      {/* Pass activePage & setActivePage to sidebar */}
      <GisSiderbar setActivePage={setActivePage} activePage={activePage} />

      <div className="page-wrapper chiller-theme toggled gismainbox">
        <main id="main" className="main">
          <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
            <nav>
              <h1> GIS Dashboard</h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">Admin</li>
                <li className="breadcrumb-item active">
                  {activePage === "gis" && "GIS Dashboard"}
                  {activePage === "analytics" && "Scheme Dashboard"}
                  {activePage === "mis" && "MIS Reports"}
                  {activePage === "survey" && "Survey Data Count"}
                  {activePage === "bhuvan" && "Bhuvan Map"}
                  {activePage === "assignTarget" && "Assign Target"}
                  {activePage === "Powerbi" && "Power BI Dashboard"}
                </li>
              </ol>
            </nav>
          </div>

          <div className="container-fluid">
            <div className="card">
              <div className="row">{renderContent()}</div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default GISDashboard;
